/**
 * Component to pick which company-wide boxes a carrier uses, and its default.
 *
 * @component
 */

import React, { Component } from "react";
import { Row, Col, Checkbox, Radio } from "antd";
import './ReturnLabelDimensions.css';

class ReturnLabelDimensions extends Component {
  constructor(props) {
    super(props);
  }

  toggleBox = (boxId, checked) => {
    const enabledBoxIds = this.props.enabledBoxIds || [];
    const nextEnabledBoxIds = checked
      ? [...enabledBoxIds, boxId]
      : enabledBoxIds.filter((id) => id !== boxId);
    this.props.handleChange('enabledBoxIds', nextEnabledBoxIds);
    if (!checked && this.props.defaultBoxId === boxId) {
      this.props.handleChange('defaultBoxId', null);
    }
  };

  setDefaultBox = (boxId) => {
    this.props.handleChange('defaultBoxId', boxId);
  };

  render() {
    const companyBoxes = this.props.companyBoxes || [];
    const enabledBoxIds = this.props.enabledBoxIds || [];

    return (
      <React.Fragment>
        <Row className="return-label-dimensions" type="flex" justify="space-around" align="middle">
          <Col span={10}>
            <h4>Boxes</h4>
            <span>
              Choose which boxes (configured in the Boxes tab) this carrier can
              use, and pick one as the default. Manage box dimensions and
              weight in the Boxes tab.
            </span>
          </Col>
          <Col span={10}>
            {companyBoxes.length === 0 ? (
              <span>No boxes configured yet. Add one in the Boxes tab first.</span>
            ) : (
              <Radio.Group
                style={{ width: "100%" }}
                value={this.props.defaultBoxId}
                onChange={(e) => this.setDefaultBox(e.target.value)}
              >
                {companyBoxes.map((box) => {
                  const checked = enabledBoxIds.includes(box.id);
                  return (
                    <Row key={box.id} style={{ marginTop: "2%" }}>
                      <Col span={16}>
                        <Checkbox
                          checked={checked}
                          onChange={(e) => this.toggleBox(box.id, e.target.checked)}
                        >
                          {box.name} ({box.length} x {box.width} x {box.height} {box.dimensionsUnit}, {box.tareWeight} {box.weightUnit})
                        </Checkbox>
                      </Col>
                      <Col span={8}>
                        <Radio value={box.id} disabled={!checked}>
                          Default box
                        </Radio>
                      </Col>
                    </Row>
                  );
                })}
              </Radio.Group>
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default ReturnLabelDimensions;
